export default __webpack_public_path__ + "static/Anupama-fe14599c4d03120db4ade4cc2d6930d5.jpg";